var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPraivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.741,
    height: 11.385,
    viewBox: "0 0 11.741 11.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icognito-svgrepo-com",
    transform: "translate(0 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6898",
    "data-name": "Path 6898",
    d: "M42.108,204.981A2.138,2.138,0,0,0,40.1,206.4H39.14a2.135,2.135,0,1,0,.092,1.067H40a2.135,2.135,0,1,0,2.1-2.491Zm-4.981,3.2a1.068,1.068,0,1,1,1.068-1.068A1.069,1.069,0,0,1,37.127,208.184Zm4.981,0a1.068,1.068,0,1,1,1.068-1.068A1.069,1.069,0,0,1,42.108,208.184Z",
    transform: "translate(-33.747 -192.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6899",
    "data-name": "Path 6899",
    d: "M11.207,9.981H9.814L9.489,8.273v0L9.1,6.211A.534.534,0,0,0,8.718,5.8L6,5.02a.534.534,0,0,0-.3,0L3.021,5.8a.534.534,0,0,0-.376.413l-.393,2.06v0L1.926,9.981H.534a.534.534,0,1,0,0,1.067H11.207a.534.534,0,1,0,0-1.067ZM5.855,6.089l2.254.645.212,1.112H3.42l.212-1.113ZM3.013,9.981l.2-1.067H8.524l.2,1.067Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPraivateIcon);
export default __webpack_public_path__ + "static/media/praivate-icon.8617cec64c31751c58ea6102b70b8e93.svg";
export { ForwardRef as ReactComponent };